<template>
	<div class="code">
		<img :src="wechatImg" alt />
		<p>微信扫码</p>
	</div>
</template>
<script>
export default {
	data() {
		return {
			wechatImg: require("@/assets/images/code.png"),
		};
	},
};
</script>
<style scoped lang="scss">
.code {
	padding: 24px 0 10px;
	text-align: center;
	img {
		height: 97px;
		width: 97px;
	}
	p {
		margin-top: 6px;
		font-size: 12px;
		color: #666;
	}
}
</style>
